import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RandomuserService {

  constructor( private http: HttpClient ) { }

  getUser():any {

    return this.http.get('https://randomuser.me/api/');

  }
}
